var map = {
	"./ads/ads01.png": "./img/ads/ads01.png",
	"./ads/ads02.png": "./img/ads/ads02.png",
	"./ads/ads03.png": "./img/ads/ads03.png",
	"./assets/1200x800.png": "./img/assets/1200x800.png",
	"./assets/arrow.png": "./img/assets/arrow.png",
	"./assets/contact-img.svg": "./img/assets/contact-img.svg",
	"./assets/fb-logo.png": "./img/assets/fb-logo.png",
	"./assets/footer-logo.svg": "./img/assets/footer-logo.svg",
	"./assets/header-logo-sp.svg": "./img/assets/header-logo-sp.svg",
	"./assets/header-logo.svg": "./img/assets/header-logo.svg",
	"./assets/x-logo-w.png": "./img/assets/x-logo-w.png",
	"./assets/x-logo.png": "./img/assets/x-logo.png",
	"./modal/iwatemeijyo_sp.png": "./img/modal/iwatemeijyo_sp.png",
	"./modal/ohsukanko_sp.png": "./img/modal/ohsukanko_sp.png",
	"./service/photo_sale_01.png": "./img/service/photo_sale_01.png",
	"./service/photo_sale_02.png": "./img/service/photo_sale_02.png",
	"./service/photo_sale_03.png": "./img/service/photo_sale_03.png",
	"./service/price-sp.png": "./img/service/price-sp.png",
	"./service/price.png": "./img/service/price.png",
	"./test/canal.jpg": "./img/test/canal.jpg",
	"./test/person.jpg": "./img/test/person.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img sync recursive \\.(png%7Cjpe?g%7Cgif%7Csvg)$";